__webpack_require__.p = "/safar-khana/";